/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Modal,
  DatePicker,
  TimePicker,
  Typography,
  Switch,
  Input,
  InputNumber,
} from 'antd';
import { formatReceived } from 'utils/formatValues';
import { onError } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import NumericInput from 'components/NumericInput';
import MultiDatePicker from 'components/MultiDatePicker';
import percentFormatter from 'utils/percentFormatter';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import { getEstadosGlobales } from 'api/catalogos/index';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
import {
  getIncidenciasEmpleadosDetalles,
  postIncidenciaEmpleadoDetalle,
  deleteIncidenciaEmpleadoDetalle,
  patchIncidenciaEmpleadoDetalle,
  getIncidenciaEmpleadoDetalle,
} from 'api/nominas/incidencias/incidenciasEmpleadosDetalles';
import { getConfiguracionIncidencia } from 'api/nominas/incidencias/configuracionIncidencias';
import { getCategoriasDeIncapacidades } from 'api/catalogos/categoriasIncapacidades';
import { getSubcategoriasDeIncapacidades } from 'api/catalogos/subcategoriasIncapacidades';
import { getPorcentajesDeSueldos } from 'api/catalogos/porcentajePagoSueldo';
import { getMotivosDePermisos } from 'api/catalogos/motivosPermisos';
import { getTiposDeIncidenciasUnidades } from 'api/nominas/incidencias/tiposIncidenciasUnidades';
import { checkToken } from 'api/utils';
import {
  FLOAT_NUMER_PATTERN,
} from 'utils/patterns';
import moment from 'moment';
import PercentageInput from 'components/PercentageInput';
import { ESTATUS_AUTORIZADO, INCIDENCIA_INCAPACIDAD, TIPO_DE_INCIDENCIAS_UNIDAD_DIAS } from 'utils/constants';
import { getPeriodosDeNominas } from 'api/nominas/periodos/periodosDeNominas';
import { getHistoricosIncapacidades, postHistoricoIncapacidad } from 'api/nominas/incapacidades/historicoIncapacidades';
import { getIncidenciasEmpleadosDiasAcumulados } from 'api/nominas/incidencias/incidenciasEmpleadosDíaAcumulado';
import { getDiasFestivosDelAño } from 'api/configuraciones/clock/DiasFestivos/FestivosDelAño';

export const incidenciasEmpleadosDetallesPermission = {
  permissionModel: 'incidenciaempleadodetalle',
  catalogsModels: [],
  tabsModels: [],
};

const { Text } = Typography;

const IncidenciasEmpleadosDetalles = ({
  permission,
  selected,
  selectedTipoIncidencia,
  selectedEmpleado,
  tipoDeNominaEmpleadoId,
  requirePeriodo,
  selectedIncidencia,
  isBlocked,
  aplicaAntiguedad,
  sueldoDiarioBase,
  horasJornadaBase,
  refreshDiasKey,
}) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowKeysDiaAcumulado, setSelectedRowKeysDiaAcumulado] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [tiposIncidenciasUnidades, setTiposIncidenciasUnidades] = useState([]);
  const [periodosNominasDetalles, setPeriodosNominasDetalles] = useState([]);
  const [fechaInicial, setFechaInicial] = useState();
  const [fechaFinal, setFechaFinal] = useState();
  const [incidencia, setIncidencia] = useState();
  const [categoriaIncapacidades, setCategoriaIncapacidades] = useState([]);
  const [subcategoriaIncapacidades, setSubcategoriaIncapacidades] = useState([]);
  const [motivosDePermisos, setMotivosDePermisos] = useState([]);
  const [porcentajesDePagoDeSueldos, setPorcentajesDePagoDeSueldos] = useState([]);
  const [selectedPorcentajePagoSueldo, setSelectedPorcentajePagoSueldo] = useState();
  const [incidenciasEmpleadosDiasAcumulados, setIncidenciasEmpleadosDiasAcumulados] = useState([]);
  const [pageActual, setPageActual] = useState(1);
  // eslint-disable-next-line no-unused-vars
  const [_selectedRecord, setSelectedRecord] = useState([]);
  const [detectarAuto, setDetectarAuto] = useState(false);
  const [diasFestivos, setDiasFestivos] = useState([]);

  const incidenciaEntrada = Form.useWatch('incidencia_en_hora_de_entrada', form);
  const incidenciaSalida = Form.useWatch('incidencia_en_hora_de_salida', form);
  const incidenciaSubcategoriaId = Form.useWatch('incidencia_subcategoria', form);
  // La clave de "Inicio" no está estandarizada entre entidades/cargas de catálogo
  // (se han visto 'IN', 'INI', 'I-IN' para el mismo concepto) -- comparar por
  // concepto normalizado evita depender de esa convención (mismo criterio que el
  // backend en IncidenciaEmpleadoDetalleModelSerializer.validate()).
  const subcategoriaEsInicio = (() => {
    const seleccionada = subcategoriaIncapacidades.find(
      (item) => item?.id === incidenciaSubcategoriaId,
    );
    const concepto = (seleccionada?.concepto || '').trim().toUpperCase();
    return !!seleccionada && ['INICIO', 'INICIAL'].includes(concepto);
  })();

  // 1. Validamos si la unidad seleccionada es Horas
  const isUnidadHoras = () => {
    // eslint-disable-next-line max-len
    const unidad = tiposIncidenciasUnidades.find((e) => e.id === selectedTipoIncidencia)?.descripcion?.toUpperCase();
    return unidad === 'HORAS';
  };

  // Redondeo a n decimales aplicado tras cada operación, igual que
  // redondearDecimales() en el backend (nominas/utils/generales.py), para que
  // el importe mostrado no arrastre precisión de punto flotante que el
  // backend nunca ve (ahí cada paso se redondea antes del siguiente cálculo).
  const redondearDecimales = (importe, decimales = 2) => {
    if (importe === null || importe === undefined || Number.isNaN(importe)) return 0;
    const factor = 10 ** decimales;
    return Math.round((importe + Number.EPSILON) * factor) / factor;
  };

  // 2. Función centralizada para realizar los cálculos financieros
  const calcularValores = (allValues) => {
    const unidadHoras = isUnidadHoras();

    const sueldoDiario = parseFloat(allValues.sueldo_diario) || 0;
    const sueldoSemanal = redondearDecimales(sueldoDiario * 7);
    const horasSemanales = parseFloat(allValues.numero_horas_jornada) || 0;
    const cantidad = parseFloat(allValues.cantidad) || 0;
    const vecesPago = parseFloat(allValues.numero_veces_pago) || 1;

    // Sueldo por Hora = Sueldo Diario / Número de Horas de la Jornada
    // (Semanal para la mayoría de incidencias; Diaria para P146 - HORAS EXTRA)
    const sueldoHora = horasSemanales > 0
      ? redondearDecimales(sueldoDiario / horasSemanales)
      : 0;

    let importePago = 0;

    if (unidadHoras) {
      importePago = redondearDecimales(sueldoHora * vecesPago * cantidad);
    } else {
      importePago = redondearDecimales(sueldoDiario * cantidad);
    }

    const totalIncapacidad = redondearDecimales(sueldoDiario * cantidad);

    form.setFieldsValue({
      sueldo_semanal: sueldoSemanal.toFixed(2),
      sueldo_por_hora: sueldoHora.toFixed(2),
      importe_pago: importePago.toFixed(2),
      total_incapacidad: totalIncapacidad.toFixed(2),
    });
  };

  const sortDiasActivos = (items) => [...items].sort((a, b) => {
    const idA = a.estados_globales?.id ?? a.estados_globales;
    const idB = b.estados_globales?.id ?? b.estados_globales;
    return (idA === 1 ? 0 : 1) - (idB === 1 ? 0 : 1);
  });

  const fetchPaginated = async (page = 1, q = null) => {
    try {
      setLoading(true);
      const cleanPage = Number(String(page).replace(/\D/g, ''));
      const _data = await getIncidenciasEmpleadosDiasAcumulados({
        page: cleanPage,
        empleado: selectedEmpleado,
        incidencia: selectedIncidencia,
        ...q,
      });

      const results = _data?.results || [];

      setSelectedRowKeysDiaAcumulado([]);
      setPageActual(cleanPage);
      setIncidenciasEmpleadosDiasAcumulados({ ..._data, results: sortDiasActivos(results) });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  // Fórmula matemática: días hábiles (lun-vie) entre dos fechas sin ciclos
  const countDiasHabiles = (inicio, fin) => {
    const n = fin.diff(inicio, 'days') + 1;
    const sd = (inicio.day() + 6) % 7; // lun=0 ... dom=6
    const fullWeeks = Math.floor(n / 7);
    const rem = n % 7;
    return fullWeeks * 5
      + Math.min(rem, Math.max(0, 5 - sd))
      + Math.max(0, rem - (7 - sd));
  };

  const calcularCantidadEnRango = (inicio, fin, overrides = {}) => {
    const fv = { ...form.getFieldsValue(), ...overrides };
    const esHabiles = fv.aplica_dias_habiles;
    const excluirFestivos = fv.aplica_dias_festivos;
    const total = fin.diff(inicio, 'days') + 1;

    let count = esHabiles ? countDiasHabiles(inicio, fin) : total;

    if (excluirFestivos) {
      const enRango = diasFestivos.filter((f) => {
        const fd = moment(f.fecha);
        if (fd.isBefore(inicio, 'day') || fd.isAfter(fin, 'day')) return false;
        // Si ya excluimos fines de semana, no restar festivos que caigan en fin de semana
        return !(esHabiles && (fd.day() === 0 || fd.day() === 6));
      });
      count -= enRango.length;
    }

    return Math.max(0, count);
  };

  const recalcularSiFechas = (overrides = {}) => {
    if (fechaInicial && fechaFinal && fechaFinal >= fechaInicial && !isUnidadHoras()) {
      const cantidad = calcularCantidadEnRango(fechaInicial, fechaFinal, overrides);
      form.setFieldsValue({ cantidad });
      calcularValores({ ...form.getFieldsValue(), cantidad });
    }
  };

  // 3. Modificamos el conteo automático de días saltándonoslo si es Horas
  const calcularCantidadQuincena = (date) => {
    const day = date.date();
    return day <= 15 ? day : Math.min(day - 15, 15);
  };

  const fechaInicialChange = (date) => {
    if (date) {
      setFechaInicial(date);
      if (incidencia?.requiere_fecha_final_abierta) {
        const cantidad = calcularCantidadQuincena(date);
        form.setFieldsValue({ cantidad });
        calcularValores({ ...form.getFieldsValue(), cantidad });
      } else if (fechaFinal && fechaFinal >= date && !isUnidadHoras()) {
        const cantidad = calcularCantidadEnRango(date, fechaFinal);
        form.setFieldsValue({ cantidad });
        calcularValores({ ...form.getFieldsValue(), cantidad });
      }
    } else if (!isUnidadHoras()) form.setFieldsValue({ cantidad: '' });
  };

  const fechaFinalChange = (date) => {
    if (date) {
      setFechaFinal(date);
      if (fechaInicial && date >= fechaInicial && !isUnidadHoras()) {
        const cantidad = calcularCantidadEnRango(fechaInicial, date);
        form.setFieldsValue({ cantidad });
        calcularValores({ ...form.getFieldsValue(), cantidad });
      }
    } else if (!isUnidadHoras()) form.setFieldsValue({ cantidad: '' });
  };

  const fetchDiasAcumulados = async () => {
    if (!selectedEmpleado || !selectedIncidencia) {
      setIncidenciasEmpleadosDiasAcumulados({ results: [], count: 0 });
      return;
    }
    const _dias = await getIncidenciasEmpleadosDiasAcumulados({
      empleado: selectedEmpleado,
      incidencia: selectedIncidencia,
    });
    const diasResults = _dias?.results || (_dias ? [_dias] : []);
    setIncidenciasEmpleadosDiasAcumulados(
      _dias ? { ..._dias, results: sortDiasActivos(diasResults) } : { results: [], count: 0 },
    );
  };

  useEffect(() => {
    if (refreshDiasKey > 0) {
      fetchDiasAcumulados();
    }
  }, [refreshDiasKey]);

  const fetchData = async () => {
    if (!selected) {
      setData([]);
      return;
    }
    setLoading(true);
    const _data = await getIncidenciasEmpleadosDetalles({
      incidencia_empleado: selected,
      empleado: selectedEmpleado,
    });
    setData(formatReceived(_data));
    setLoading(false);
  };

  // 4. Se ejecuta el recálculo cuando se tocan campos determinantes
  const handleValuesChange = (changedValues, allValues) => {
    const triggerFields = ['sueldo_diario', 'numero_horas_jornada', 'cantidad', 'numero_veces_pago'];
    if (triggerFields.some((field) => field in changedValues)) {
      calcularValores(allValues);
    }
  };

  useEffect(() => {
    let mounted = true;

    const fetchAll = async () => {
      if (!selected) {
        setData([]);
        return;
      }
      setLoading(true);
      await checkToken();

      const [
        _estados,
        _tiposIncidenciasUnidades,
        _periodosNominasDetalles,
        _periodosDeNominas,
        _incidencia,
        _categoriasIncapacidades,
        _subcategoriasIncapacidades,
        _porcentajeDeSueldos,
        _data,
        _diasFestivos,
        _motivosDePermisos,
      ] = await Promise.all([
        getEstadosGlobales(),
        getTiposDeIncidenciasUnidades(),
        getPeriodosDeNominasDetalles(
          tipoDeNominaEmpleadoId
            ? { periodo_de_nomina__tipo_de_nomina_empleado: tipoDeNominaEmpleadoId }
            : undefined,
        ),
        getPeriodosDeNominas(),
        getConfiguracionIncidencia(selectedIncidencia),
        getCategoriasDeIncapacidades({ estados_globales: ESTATUS_AUTORIZADO }),
        getSubcategoriasDeIncapacidades({ estados_globales: ESTATUS_AUTORIZADO }),
        getPorcentajesDeSueldos({ estados_globales: ESTATUS_AUTORIZADO }),
        getIncidenciasEmpleadosDetalles({ incidencia_empleado: selected }),
        getDiasFestivosDelAño({ page_size: 1000 }),
        getMotivosDePermisos(),
      ]);

      // Cargar días acumulados por separado para garantizar filtro correcto
      await fetchDiasAcumulados();

      if (mounted) {
        setEstados(_estados);
        setTiposIncidenciasUnidades(_tiposIncidenciasUnidades);
        // Los periodos de nómina válidos son los que existen en el catálogo Y,
        // si se conoce el Tipo de Nómina Empleado real del empleado, los que
        // pertenecen a su mismo calendario -- de lo contrario el motor de
        // cálculo nunca hará coincidir el periodo elegido (comparación exacta
        // de id) y el descuento/incidencia queda huérfano en silencio.
        const periodosDeNominaValidos = tipoDeNominaEmpleadoId
          ? _periodosDeNominas.filter((pn) => pn.tipo_de_nomina_empleado === tipoDeNominaEmpleadoId)
          : _periodosDeNominas;
        setPeriodosNominasDetalles(
          // eslint-disable-next-line max-len
          _periodosNominasDetalles.filter((p) => periodosDeNominaValidos.some((pn) => pn.id === p?.periodo_de_nomina)),
        );
        setIncidencia(_incidencia);
        setCategoriaIncapacidades(_categoriasIncapacidades);
        setSubcategoriaIncapacidades(_subcategoriasIncapacidades);
        setPorcentajesDePagoDeSueldos(_porcentajeDeSueldos);
        setData(formatReceived(_data));
        setDiasFestivos(
          Array.isArray(_diasFestivos) ? _diasFestivos : (_diasFestivos?.results || []),
        );
        setMotivosDePermisos(_motivosDePermisos);
        setLoading(false);
      }
    };

    fetchAll();
    return () => { mounted = false; };
  }, [selected, selectedEmpleado, selectedIncidencia, tipoDeNominaEmpleadoId]);

  const onCancel = () => {
    setSelectedRowKeys([]);
    setVisible(false);
    form.resetFields();
    setFechaFinal();
    setFechaInicial();
    setSelectedPorcentajePagoSueldo();
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    setDetectarAuto(false);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _incidencia = await getIncidenciaEmpleadoDetalle(match.id);
    setTimeout(() => {
      if (_incidencia) {
        form.resetFields();
        setTimeout(() => {
          setSelectedRecord(_incidencia);
          // eslint-disable-next-line max-len
          form.setFieldsValue({
            // dias_que_labora/dias_que_no_labora se toman de _incidencia (crudo,
            // no de formatReceived) porque un arreglo de una sola fecha calza
            // con el regex de fecha de formatReceived y se convertiría, por
            // error, en un Moment en vez de conservarse como arreglo.
            ...formatReceived(_incidencia),
            // incidencia_en_hora_de_entrada/salida y minutos son campos de
            // IncidenciaEmpleadoDetalle; se resguarda el default para
            // registros antiguos que no los tenían.
            incidencia_en_hora_de_entrada: _incidencia?.incidencia_en_hora_de_entrada ?? false,
            minutos_de_entrada: _incidencia?.minutos_de_entrada ?? null,
            incidencia_en_hora_de_salida: _incidencia?.incidencia_en_hora_de_salida ?? false,
            minutos_de_salida: _incidencia?.minutos_de_salida ?? null,
            dias_que_labora: _incidencia?.dias_que_labora ?? [],
            dias_que_no_labora: _incidencia?.dias_que_no_labora ?? [],
          });
          // Solo se recalcula si el registro nunca tuvo un importe de pago
          // guardado (ej. datos antiguos). De lo contrario se respeta el valor
          // ya persistido, para no sobrescribirlo con el simple hecho de abrir
          // el registro para consulta/edición.
          if (_incidencia.importe_pago === null || _incidencia.importe_pago === undefined) {
            calcularValores(form.getFieldsValue());
          }
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const generateHistorial = async (values, id) => {
    if (incidencia.aplica_catalogos_adicionales
      && incidencia.aplica_categorias_de_incapacidades
      && incidencia.aplica_subcategorias_de_incapacidades
      && incidencia.tipo_de_incidencia_unidad === TIPO_DE_INCIDENCIAS_UNIDAD_DIAS
      && incidencia.tipo_de_incidencia === INCIDENCIA_INCAPACIDAD
    ) {
      const historicosIncapacidades = await
      getHistoricosIncapacidades({ empleado: selectedEmpleado });

      const historicoValues = {
        numero_incapacidad: historicosIncapacidades.length + 1,
        fecha_ejecucion: values?.fecha_alta,
        fecha_inicial: values?.fecha_inicial,
        fecha_final: values?.fecha_final,
        dias_de_incapacidad: values?.cantidad,
        incidencia: incidencia.id,
        incidencia_categoria: values?.incidencia_categoria,
        incidencia_subcategoria: values?.incidencia_subcategoria,
        incidencia_empleado_detalle: id,
        empleado: selectedEmpleado,
      };
      await postHistoricoIncapacidad(historicoValues);
    }
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();

      const allValues = form.getFieldsValue();
      const {
        incidencia_en_hora_de_entrada,
        minutos_de_entrada,
        horario_de_entrada,
        incidencia_en_hora_de_salida,
        minutos_de_salida,
        horario_de_salida,
        ...detailValues
      } = allValues;

      // incidencia_en_hora_de_entrada/salida y sus minutos/horarios son campos
      // del modelo IncidenciaEmpleadoDetalle (por periodo), no de IncidenciaEmpleado
      // (el padre) -- ese modelo no los tiene, por eso deben ir en el payload
      // del detalle y no mandarse por separado al padre.
      const values = {
        ...detailValues,
        detectar_periodos_auto: detectarAuto,
        incidencia_empleado: selected,
        tipo_de_incidencia_unidad: selectedTipoIncidencia,
        empleado: selectedEmpleado,
      };

      if (incidencia?.aplica_incidencia_en_horario) {
        values.incidencia_en_hora_de_entrada = incidencia_en_hora_de_entrada ?? false;
        values.minutos_de_entrada = incidencia_en_hora_de_entrada ? minutos_de_entrada : null;
        // eslint-disable-next-line max-len
        values.horario_de_entrada = incidencia_en_hora_de_entrada ? horario_de_entrada?.format('HH:mm:ss') : null;
        values.incidencia_en_hora_de_salida = incidencia_en_hora_de_salida ?? false;
        values.minutos_de_salida = incidencia_en_hora_de_salida ? minutos_de_salida : null;
        values.horario_de_salida = incidencia_en_hora_de_salida ? horario_de_salida?.format('HH:mm:ss') : null;
      }

      // Cuando la incidencia aplica_incidencia_en_dias_laborados, se capturan
      // días específicos (no un rango) -- fecha_inicial/fecha_final van null
      // y dias_que_labora/dias_que_no_labora llevan las fechas seleccionadas.
      if (incidencia?.aplica_incidencia_en_dias_laborados) {
        values.fecha_inicial = null;
        values.fecha_final = null;
      } else {
        values.dias_que_labora = [];
        values.dias_que_no_labora = [];
      }

      const [key] = selectedRowKeys;
      if (!key) {
        delete values.id;
      }

      const saved = await (key ? patchIncidenciaEmpleadoDetalle(key, values)
        : postIncidenciaEmpleadoDetalle(values));

      if (saved) {
        if (!key) {
          generateHistorial(values, saved?.id);
        }
        if (_continue) {
          await fetchData();
          await fetchDiasAcumulados();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
          await fetchDiasAcumulados();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteIncidenciaEmpleadoDetalle(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
          await fetchDiasAcumulados();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);

    const parsedRecord = {
      ...record,
      fecha_alta: record.fecha_alta ? moment(record.fecha_alta) : null,
      fecha_inicial: record.fecha_inicial ? moment(record.fecha_inicial) : null,
      fecha_final: record.fecha_final ? moment(record.fecha_final) : null,
      // eslint-disable-next-line max-len
      horario_de_entrada: record.horario_de_entrada ? moment(record.horario_de_entrada, 'HH:mm:ss') : null,
      // eslint-disable-next-line max-len
      horario_de_salida: record.horario_de_salida ? moment(record.horario_de_salida, 'HH:mm:ss') : null,
    };

    form.setFieldsValue(parsedRecord);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setDetectarAuto(false);
    const initValues = {
      fecha_alta: moment(new Date().getDate(), 'DD/MM/YYYY'),
      sueldo_diario: sueldoDiarioBase,
      numero_horas_jornada: horasJornadaBase,
      numero_veces_pago: 1, // Por default seteado a Sencillo
    };
    form.setFieldsValue(initValues);

    // Forzamos el cálculo inicial de Sueldo Semanal y Sueldo por Hora
    setTimeout(() => calcularValores(form.getFieldsValue()), 50);

    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const columns = [
    {
      titleText: 'Fecha de Alta',
      dataIndex: 'fecha_alta',
      key: 'fecha_alta',
      width: 200,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Cantidad',
      dataIndex: 'cantidad',
      key: 'cantidad',
      width: 200,
    },
    {
      titleText: 'Unidad de Incidencia',
      dataIndex: 'tipo_de_incidencia_unidad',
      key: 'tipo_de_incidencia_unidad',
      width: 200,
      render: (val) => tiposIncidenciasUnidades.find((e) => e.id === val)?.descripcion,
    },
    // Nota: las 4 columnas se mantienen siempre presentes en el arreglo (en
    // vez de intercambiar claves según incidencia?.aplica_incidencia_en_dias_laborados)
    // porque Table.jsx fija sus columnas visibles (selectedCols) en el
    // primer render vía useState -- como `incidencia` se carga async DESPUÉS
    // de ese primer render, intercambiar claves aquí hacía que ninguna de
    // las dos variantes apareciera nunca en la tabla.
    {
      titleText: 'Fecha Inicial',
      dataIndex: 'fecha_inicial',
      key: 'fecha_inicial',
      width: 200,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Fecha Final',
      dataIndex: 'fecha_final',
      key: 'fecha_final',
      width: 200,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Día(s) que Labora',
      dataIndex: 'dias_que_labora',
      key: 'dias_que_labora',
      width: 250,
      render: (val) => (val || []).map((f) => moment(f).format('DD/MM/YYYY')).join(', '),
    },
    {
      titleText: 'Día(s) que No Labora',
      dataIndex: 'dias_que_no_labora',
      key: 'dias_que_no_labora',
      width: 250,
      render: (val) => (val || []).map((f) => moment(f).format('DD/MM/YYYY')).join(', '),
    },
    ...(aplicaAntiguedad ? [
      {
        titleText: '100%',
        dataIndex: 'dias_aplicados_al_100',
        key: 'dias_aplicados_al_100',
        width: 150,
        render: (val) => (val ?? 0),
      },
      {
        titleText: '50%',
        dataIndex: 'dias_aplicados_al_50',
        key: 'dias_aplicados_al_50',
        width: 150,
        render: (val) => (val ?? 0),
      },
      {
        titleText: '0%',
        dataIndex: 'dias_aplicados_al_0',
        key: 'dias_aplicados_al_0',
        width: 150,
        render: (val) => (val ?? 0),
      },
    ] : []),
    {
      titleText: 'Dias Adicionales',
      dataIndex: 'dias_adicionales',
      key: 'dias_adicionales',
      width: 150,
      disable: true,
    },
    {
      titleText: 'Nómina de Aplicación',
      dataIndex: 'periodo_de_nomina_detalle',
      key: 'periodo_de_nomina_detalle',
      width: 300,
      render: (val) => {
        const _periodo = periodosNominasDetalles.find((e) => e.id === val);
        const _renderPeriodo = `${_periodo?.numero_de_nomina} (${_periodo?.fecha_inicial} al ${_periodo?.fecha_final})`;
        return _periodo ? _renderPeriodo : '';
      },
    },
    {
      titleText: 'Categoría de Incapacidad',
      dataIndex: 'incidencia_categoria',
      key: 'incidencia_categoria',
      width: 300,
      render: (val) => {
        const catInc = categoriaIncapacidades.find((item) => item?.id === val);
        return catInc ? `${catInc?.clave} - ${catInc?.concepto}` : '';
      },
    },
    {
      titleText: 'Subcategoría de Incapacidades',
      dataIndex: 'incidencia_subcategoria',
      key: 'incidencia_subcategoria',
      width: 300,
      render: (val) => {
        const subcatInc = subcategoriaIncapacidades.find((item) => item?.id === val);
        return subcatInc ? `${subcatInc?.clave} - ${subcatInc?.concepto}` : '';
      },
    },
    {
      titleText: 'Días Acumulados del IMSS',
      dataIndex: 'dias_acumulados_imss',
      key: 'dias_acumulados_imss',
      width: 200,
    },
    {
      titleText: 'Folio Agrupador',
      dataIndex: 'folio_agrupador',
      key: 'folio_agrupador',
      width: 200,
    },
    {
      titleText: 'Porcentaje de Sueldo a Pagar',
      dataIndex: 'incidencia_porcentaje_de_sueldo',
      key: 'incidencia_porcentaje_de_sueldo',
      width: 300,
      render: (val) => {
        const porcPago = porcentajesDePagoDeSueldos.find((item) => item?.id === val);
        return porcPago ? `${porcPago?.clave} - ${porcPago?.concepto}` : '';
      },
    },
    {
      titleText: 'Porcentaje Personalizado',
      dataIndex: 'porcentaje_sueldo_personalizado',
      key: 'porcentaje_sueldo_personalizado',
      width: 250,
      render: (val) => percentFormatter(val || 0),
    },
    {
      titleText: 'Motivo de Permisos',
      dataIndex: 'incidencia_motivo_de_permiso',
      key: 'incidencia_motivo_de_permiso',
      width: 300,
      render: (val) => {
        const motivoPermiso = motivosDePermisos.find((item) => item?.id === val);
        return motivoPermiso ? `${motivoPermiso?.clave} - ${motivoPermiso?.concepto}` : '';
      },
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const columnasDias = [
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 150,
      render: (val) => val?.descripcion ?? estados.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: 'Fecha de Registro',
      dataIndex: 'fecha_de_registro',
      key: 'fecha_de_registro',
      width: 160,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : '—'),
    },
    {
      titleText: 'Fecha de Alta IMSS',
      dataIndex: 'fecha_de_alta_imss',
      key: 'fecha_de_alta_imss',
      width: 160,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : '—'),
    },
    {
      titleText: 'No. de Documento',
      dataIndex: 'no_de_documento',
      key: 'no_de_documento',
      width: 200,
      render: (val) => val ?? '—',
    },
    {
      titleText: 'Folio Agrupador',
      dataIndex: 'folio_agrupador',
      key: 'folio_agrupador',
      width: 200,
      render: (val) => val ?? '—',
    },
    {
      titleText: 'Límite de Días al 100%',
      dataIndex: 'limite_de_dias_al_100',
      key: 'limite_de_dias_al_100',
      width: 200,
      render: (val) => (val ?? 0),
    },
    {
      titleText: 'Días Aplicados al 100%',
      dataIndex: 'dias_aplicados_al_100',
      key: 'dias_aplicados_al_100',
      width: 200,
      render: (val) => (val ?? 0),
    },
    {
      titleText: 'Días por Aplicar al 100%',
      dataIndex: 'dias_por_aplicar_al_100',
      key: 'dias_por_aplicar_al_100',
      width: 200,
      render: (val) => (val ?? 0),
    },
    {
      titleText: 'Límite de Días al 50%',
      dataIndex: 'limite_de_dias_al_50',
      key: 'limite_de_dias_al_50',
      width: 200,
      render: (val) => (val ?? 0),
    },
    {
      titleText: 'Días Aplicados al 50%',
      dataIndex: 'dias_aplicados_al_50',
      key: 'dias_aplicados_al_50',
      width: 200,
      render: (val) => (val ?? 0),
    },
    {
      titleText: 'Días por Aplicar al 50%',
      dataIndex: 'dias_por_aplicar_al_50',
      key: 'dias_por_aplicar_al_50',
      width: 200,
      render: (val) => (val ?? 0),
    },
    {
      titleText: 'Límite de Días al 0%',
      dataIndex: 'limite_de_dias_al_0',
      key: 'limite_de_dias_al_0',
      width: 200,
      render: (val) => (val ?? 0),
    },
    {
      titleText: 'Días Aplicados al 0%',
      dataIndex: 'dias_aplicados_al_0',
      key: 'dias_aplicados_al_0',
      width: 200,
      render: (val) => (val ?? 0),
    },
    {
      titleText: 'Días por Aplicar al 0%',
      dataIndex: 'dias_por_aplicar_al_0',
      key: 'dias_por_aplicar_al_0',
      width: 200,
      render: (val) => (val ?? 0),
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    contratacion: [requiredRule],
    estatus: [requiredRule],
    startDate: [
      { required: true },
      {
        validator: async () => {
          const { fecha_inicial, fecha_final } = form.getFieldsValue();
          const [fechaIni, fechaFin] = [new Date(fecha_inicial), new Date(fecha_final)];
          if (fechaIni && fechaFin && fechaIni > fechaFin) {
            throw new Error('Este campo debe ser menor o igual que la Fecha Final');
          }
        },
      },
    ],
    endDate: [
      { required: true },
      {
        validator: async () => {
          const { fecha_inicial, fecha_final } = form.getFieldsValue();
          const [fechaIni, fechaFin] = [new Date(fecha_inicial), new Date(fecha_final)];
          if (fechaIni && fechaFin && fechaIni > fechaFin) {
            throw new Error('Este campo debe ser mayor o igual que la Fecha Inicial');
          }
        },
      },
    ],
    endDateOpen: [],
    valor: [
      requiredRule,
      {
        pattern: FLOAT_NUMER_PATTERN,
        message: 'Ingrese un valor válido',
      },
    ],
    valorPorcentaje: [
      requiredRule,
      {
        validator: async () => {
          const porcentaje = form.getFieldValue('porcentaje_sueldo_personalizado');
          if (porcentaje < 1 || porcentaje > 100) {
            throw new Error('Este campo debe ser mayor que 1 o menor que 100');
          }
        },
      },
    ],
    horasJornada: [
      {
        validator: async (_rule, value) => {
          if (value !== undefined && value !== null && value !== '' && Number(value) < 0) {
            throw new Error('El número de horas de la jornada no puede ser negativo');
          }
        },
      },
    ],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit: () => onClickEdit(),
            onClickDelete,
          }}
          permission={permission}
          allowExportPDF={false}
          disableAdd={isBlocked}
          disableDelete={isBlocked}
        />

        {aplicaAntiguedad && (
        <>
          <Text style={{ color: '#D88F4F' }}>Días Acumulados</Text>

          <Table
            cols={columnasDias}
            data={incidenciasEmpleadosDiasAcumulados?.results || []}
            pagination={false}
            paginationCallback={fetchPaginated}
            count={incidenciasEmpleadosDiasAcumulados?.count || 0}
            rowSelection={{ selectedKeys: selectedRowKeysDiaAcumulado, type: 'radio' }}
            currentPage={pageActual}
            handleOnRowClick={(record) => setSelectedRowKeysDiaAcumulado([record.id])}
            allowSearch
            allowExportParam={false}
            allowColumnSelector={false}
            permission={permission}
            allowExportPDF={false}
          />
        </>
        )}
        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Incidencia`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
              // Bloqueado => sin Guardar; excepción: Fecha Final (Abierta), única editable.
              mutable={!isBlocked || !!incidencia?.requiere_fecha_final_abierta}
            />
          )}
          onCancel={onCancel}
          forceRender
          width="80%"
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            onValuesChange={handleValuesChange}
            scrollToFirstError
            name="general"
          >
            <Row gutter={10}>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="fecha_alta"
                  label="Fecha de Alta"
                >
                  <DatePicker
                    format="DD/MM/YYYY"
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <NumericInput
                  name="cantidad"
                  label="Cantidad"
                  allowClear
                  rules={rules.valor}
                  disabled={isBlocked}
                />
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  label="Unidad de Incidencia"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    value={selectedTipoIncidencia}
                    dataSource={tiposIncidenciasUnidades}
                    disabled
                  />
                </Form.Item>
              </Col>
              {!incidencia?.aplica_incidencia_en_dias_laborados ? (
                <>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="fecha_inicial"
                      label="Fecha Inicial"
                      rules={rules.startDate}
                    >
                      <DatePicker
                        format="DD/MM/YYYY"
                        placeholder=""
                        onChange={fechaInicialChange}
                        disabled={isBlocked}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="fecha_final"
                      label={incidencia?.requiere_fecha_final_abierta ? 'Fecha Final (Abierta)' : 'Fecha Final'}
                      // eslint-disable-next-line max-len
                      rules={incidencia?.requiere_fecha_final_abierta ? rules.endDateOpen : rules.endDate}
                    >
                      <DatePicker
                        format="DD/MM/YYYY"
                        placeholder={incidencia?.requiere_fecha_final_abierta ? 'Sin fecha definida' : ''}
                        onChange={fechaFinalChange}
                        disabled={incidencia?.requiere_fecha_final_abierta ? false : isBlocked}
                      />
                    </Form.Item>
                  </Col>
                </>
              ) : (
                <>
                  <Col xs={24} sm={24} md={12}>
                    <MultiDatePicker
                      name="dias_que_labora"
                      label="Día(s) que Labora"
                      disabled={isBlocked}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12}>
                    <MultiDatePicker
                      name="dias_que_no_labora"
                      label="Día(s) que No Labora"
                      disabled={isBlocked}
                    />
                  </Col>
                </>
              )}

              {incidencia?.requiere_numero_de_horas_de_la_jornada && (
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="numero_horas_jornada"
                  label="Número de Horas de la Jornada Diaria"
                  rules={rules.horasJornada}
                  hasFeedback
                >
                  <Input type="number" step="0.1" min={0} disabled={isBlocked} />
                </Form.Item>
              </Col>
              )}

              {incidencia?.requiere_sueldo_por_dia && (
              <Col xs={24} sm={24} md={8}>
                <Form.Item name="sueldo_diario" label="Sueldo Diario">
                  <Input prefix="$" type="number" step="0.01" disabled={isBlocked} />
                </Form.Item>
              </Col>
              )}

              <Form.Item name="sueldo_semanal" hidden>
                <Input />
              </Form.Item>

              <Form.Item name="total_incapacidad" hidden>
                <Input />
              </Form.Item>

              {incidencia?.requiere_sueldo_por_hora && (
              <Col xs={24} sm={24} md={8}>
                <Form.Item name="sueldo_por_hora" label="Sueldo por Hora">
                  <Input prefix="$" disabled />
                </Form.Item>
              </Col>
              )}

              {incidencia?.requiere_numero_de_veces_de_pago && (
              <Col xs={24} sm={24} md={8}>
                <Form.Item name="numero_veces_pago" label="Número de Veces de Pago">
                  <Select
                    dataSource={[
                      { id: 1, descripcion: 'Sencillo' },
                      { id: 2, descripcion: 'Doble' },
                      { id: 3, descripcion: 'Triple' },
                    ]}
                    disabled={isBlocked}
                  />
                </Form.Item>
              </Col>
              )}

              {incidencia?.requiere_importe_de_pago && (
              <Col xs={24} sm={24} md={8}>
                <Form.Item name="importe_pago" label="Importe de Pago o Descuento">
                  <Input prefix="$" type="number" step="0.01" disabled={isBlocked} />
                </Form.Item>
              </Col>
              )}
              {!selectedRowKeys.length && (
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  label="Detectar Periodos Automáticamente"
                  name="detectar_periodos_auto"
                  valuePropName="checked"
                >
                  <Switch
                    checked={detectarAuto}
                    onChange={(checked) => {
                      setDetectarAuto(checked);
                      if (checked) form.setFieldsValue({ periodo_de_nomina_detalle: null });
                    }}
                  />
                </Form.Item>
              </Col>
              )}
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="periodo_de_nomina_detalle"
                  label="Nómina de Aplicación"
                  rules={(!detectarAuto && requirePeriodo) ? rules.estatus : []}
                  hasFeedback
                >
                  <Select
                    keyProp="id"
                    labelProp="numero_de_nomina"
                    dataSource={periodosNominasDetalles}
                    render={(value) => `${value?.numero_de_nomina} (${value?.fecha_inicial} al ${value?.fecha_final})`}
                    disabled={detectarAuto || isBlocked}
                    allowClear={!detectarAuto}
                  />
                </Form.Item>
              </Col>
              {incidencia?.aplica_categorias_de_incapacidades
                && incidencia?.aplica_catalogos_adicionales
                ? (
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="incidencia_categoria"
                      label="Categoría de Incapacidades"
                      rules={rules.required}
                      hasFeedback
                    >
                      <Select
                        dataSource={categoriaIncapacidades}
                        render={(val) => `${val?.clave} - ${val?.concepto}`}
                        allowClear
                        disabled={isBlocked}
                      />
                    </Form.Item>
                  </Col>
                ) : null}
              {incidencia?.aplica_subcategorias_de_incapacidades
                && incidencia?.aplica_catalogos_adicionales
                ? (
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="incidencia_subcategoria"
                      label="Subcategoría de Incapacidades"
                      rules={rules.required}
                      hasFeedback
                    >
                      <Select
                        dataSource={subcategoriaIncapacidades}
                        render={(val) => `${val?.clave} - ${val?.concepto}`}
                        allowClear
                        disabled={isBlocked}
                        onChange={(value) => {
                          const seleccionada = subcategoriaIncapacidades.find(
                            (item) => item?.id === value,
                          );
                          const concepto = (seleccionada?.concepto || '').trim().toUpperCase();
                          const esInicio = !!seleccionada && ['INICIO', 'INICIAL'].includes(concepto);
                          if (esInicio) {
                            form.setFieldValue('dias_acumulados_imss', 0);
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>
                ) : null}
              {incidencia?.requiere_folio_agrupador ? (
                <>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="dias_acumulados_imss"
                      label="Días Acumulados del IMSS"
                      rules={rules.required}
                      hasFeedback
                    >
                      <InputNumber
                        min={0}
                        style={{ width: '100%' }}
                        disabled={isBlocked || subcategoriaEsInicio}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="folio_agrupador"
                      label="Folio Agrupador"
                    >
                      <Input disabled placeholder="Se genera automáticamente" />
                    </Form.Item>
                  </Col>
                </>
              ) : null}
              {incidencia?.aplica_motivos_de_permisos
                && incidencia?.aplica_catalogos_adicionales
                ? (
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="incidencia_motivo_de_permiso"
                      label="Motivo De Permiso"
                      rules={rules.required}
                      hasFeedback
                    >
                      <Select
                        dataSource={motivosDePermisos}
                        render={(val) => `${val?.clave} - ${val?.concepto}`}
                        allowClear
                        disabled={isBlocked}
                      />
                    </Form.Item>
                  </Col>
                ) : null}
              {selectedPorcentajePagoSueldo?.aplica_porcentaje_personalizado
                && incidencia?.aplica_catalogos_adicionales
                ? (
                  <Col xs={24} sm={24} md={8}>
                    <PercentageInput
                      allowClear
                      name="porcentaje_sueldo_personalizado"
                      label="Porcentaje De Pago De Sueldo Personalizado"
                      rules={rules.valorPorcentaje}
                      hasFeedback
                      disabled={isBlocked}
                    />
                  </Col>
                ) : null}
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="aplica_dias_habiles"
                  label="Aplica Días Hábiles"
                  hasFeedback
                  rules={rules.required}
                  initialValue={false}
                >
                  <Select
                    trueFalse
                    disabled={isBlocked}
                    onChange={(value) => {
                      if (value) form.setFieldsValue({ aplica_dias_naturales: false });
                      recalcularSiFechas({ aplica_dias_habiles: value });
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="aplica_dias_naturales"
                  label="Aplica Días Naturales"
                  hasFeedback
                  rules={rules.required}
                  initialValue={false}
                >
                  <Select
                    trueFalse
                    disabled={isBlocked}
                    onChange={(value) => {
                      if (value) form.setFieldsValue({ aplica_dias_habiles: false });
                      recalcularSiFechas({ aplica_dias_habiles: false });
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="aplica_dias_festivos"
                  label="Aplica Días Festivos"
                  hasFeedback
                  rules={rules.required}
                  initialValue={false}
                >
                  <Select
                    trueFalse
                    disabled={isBlocked}
                    onChange={(value) => recalcularSiFechas({ aplica_dias_festivos: value })}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="estados_globales"
                  label="Estatus"
                  rules={rules.estatus}
                  hasFeedback
                  initialValue={1}
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={estados}
                    disabled={selectedRowKeys.length <= 0 || isBlocked}
                  />
                </Form.Item>
              </Col>
            </Row>

            {incidencia?.aplica_incidencia_en_horario && (
              <Row gutter={10}>
                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="incidencia_en_hora_de_entrada"
                    label="Incidencia en Hora de Entrada"
                    initialValue={false}
                  >
                    <Select
                      dataSource={[{ id: true, desc: 'SI' }, { id: false, desc: 'NO' }]}
                      keyProp="id"
                      labelProp="desc"
                      render={(item) => item.desc}
                      disabled={isBlocked}
                    />
                  </Form.Item>
                </Col>

                {incidenciaEntrada && (
                  <Col xs={24} sm={12} md={8}>
                    <Form.Item
                      name="minutos_de_entrada"
                      label="Minutos de Entrada"
                      rules={[{ required: true, message: 'Requerido' }]}
                    >
                      <Input type="number" min={1} disabled={isBlocked} />
                    </Form.Item>
                  </Col>
                )}

                <Col xs={24} sm={12} md={8}>
                  <Form.Item
                    name="incidencia_en_hora_de_salida"
                    label="Incidencia en Hora de Salida"
                    initialValue={false}
                  >
                    <Select
                      dataSource={[{ id: true, desc: 'SI' }, { id: false, desc: 'NO' }]}
                      keyProp="id"
                      labelProp="desc"
                      render={(item) => item.desc}
                      disabled={isBlocked}
                    />
                  </Form.Item>
                </Col>

                {incidenciaSalida && (
                  <Col xs={24} sm={12} md={8}>
                    <Form.Item
                      name="minutos_de_salida"
                      label="Minutos de Salida"
                      rules={[{ required: true, message: 'Requerido' }]}
                    >
                      <Input type="number" min={1} disabled={isBlocked} />
                    </Form.Item>
                  </Col>
                )}

                {incidenciaEntrada && (
                  <Col xs={24} sm={12} md={8}>
                    <Form.Item
                      name="horario_de_entrada"
                      label="Horario de Entrada"
                      rules={[{ required: true, message: 'Requerido' }]}
                    >
                      <TimePicker format="hh:mm A" use24Hours style={{ width: '100%' }} disabled={isBlocked} />
                    </Form.Item>
                  </Col>
                )}

                {incidenciaSalida && (
                  <Col xs={24} sm={12} md={8}>
                    <Form.Item
                      name="horario_de_salida"
                      label="Horario de Salida"
                      rules={[{ required: true, message: 'Requerido' }]}
                    >
                      <TimePicker format="hh:mm A" use24Hours style={{ width: '100%' }} disabled={isBlocked} />
                    </Form.Item>
                  </Col>
                )}
              </Row>
            )}
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Form>
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content="la Incidencia"
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default IncidenciasEmpleadosDetalles;
